export const getTranslation = <T extends { language: string }>(
  translations: T[] | null | undefined,
  language: string | undefined,
) =>
  language
    ? translations?.find((translation) => translation.language === language)
    : undefined;
